import {
  buildLeonardoShareUrlFromSimpleConfig,
  SITE_LEONARDO_THEME_NAME,
} from '@/utils/leonardo/buildThemeShareUrl';
import { normalizeHex } from './normalizeHex';

export interface GetLeonardoUrlInput {
  baseColor: string;
  mode?: 'light' | 'dark';
  formula?: 'wcag2' | 'wcag3';
  themeName?: string;
}

export interface GetLeonardoUrlResult {
  url: string;
  themeName: string;
}

export const executeGetLeonardoUrl = (
  input: GetLeonardoUrlInput
): GetLeonardoUrlResult => {
  const baseColor = normalizeHex(input.baseColor);
  const mode = input.mode ?? 'light';
  const formula = input.formula ?? 'wcag2';
  const themeName = input.themeName ?? SITE_LEONARDO_THEME_NAME;

  const url = buildLeonardoShareUrlFromSimpleConfig(
    themeName,
    {
      baseColors: { blue: baseColor },
      backgroundColor: mode === 'dark' ? 'Black' : 'White',
      formula,
    },
    mode
  );

  return { url, themeName };
};
